<template>
  <div>
    <div v-if="['image', 'video'].includes(attachmentType)" class="sourceMessage textType">
      <div v-if="isReplyText">
        <div v-html="renderNormalChat(replyToMessage)"></div>
      </div>
      <div v-else class="sourceMessage textType flexContainer">
        <VIcon name="attachment-line"></VIcon>
        <i>Attachment</i>
      </div>
    </div>
    <div v-else-if="['text', 'document'].includes(attachmentType) && replyToTemplate">
      <div v-if="['text', 'quick_replies', 'payment_replies', 'location', 'button_message'].includes(replyToTemplate.type) || (replyToTemplate.type == 'payment' && replyToTemplate.buttons)" v-html="renderNormalChat(replyToMessage)" class="sourceMessage textType"></div> 
      <!-- carousel start -->
      <div v-else-if="replyToTemplate.type == 'generic_message' || (replyToTemplate.type == 'payment' && !replyToTemplate.buttons)" class="sourceMessage textType">
        <b>{{ replyToTemplate.message?.[0].title }}</b>
        <div v-html="renderNormalChat(replyToTemplate.message?.[0].subtitle)"></div>
      </div>
      <!-- carousel end -->

      <!-- image start -->
      <div v-else-if="replyToTemplate?.type === 'image' || replyToAttachmentType === 'image' || (replyToTemplate?.type === 'file' && replyToTemplate?.filetype === 'image')" class="sourceMessage imageType">
        <a :href="sanitizeHardLinkUrl(replyToTemplate.message)" target="_blank" rel="noreferer noopener" >
          <img :src="sanitizeHardLinkUrl(replyToTemplate.message)" class="imageInChat" />
        </a>
      </div>
      <!-- image end -->

      <!-- video start -->
      <div v-else-if="replyToTemplate?.type === 'video' || replyToAttachmentType === 'video' || (replyToTemplate?.type === 'file' && replyToTemplate?.filetype === 'video')" class="sourceMessage videoType">
        <video class="videoInChat" controls controlslist="nodownload" >
          <source :src="sanitizeHardLinkUrl(replyToAttachment ? replyToAttachment : replyToTemplate?.message)" type="video/mp4" >
        </video>
      </div>
      <!-- video end -->

      <div v-else class="sourceMessage textType">
        <i>Attachment</i>
        <VIcon :name="attachOutline"></VIcon>
      </div>
    </div>

    <div :class="['replyMessage', attachmentType + 'Type']">
      <div :class="{ 'textPadding': attachmentType == 'image' || attachmentType == 'video' }">
        <span class="displayContainer text-medium">
          <i>
            <span v-if="activeCustomer.name && !['unrecorded', 'None'].includes(activeCustomer.name)">
              {{ activeCustomer.name }}
            </span>
            <span v-else>Customer</span>
            replied to
            <span v-if="message?.replytomessage.replied">your</span>
            <span v-else>their own</span>
            message
          </i>
        </span>
      </div>

      <template v-if="['text', 'document'].includes(attachmentType)">
        <div v-html="renderNormalChat(message.message)"></div>
      </template>

      <template v-else-if="attachmentType === 'image'">
        <a :href="sanitizeHardLinkUrl(attachment)" target="_blank" rel="noreferer noopener">
          <img :src="sanitizeHardLinkUrl(attachment)" class="imageInChat" alt="image_url" />
        </a>
      </template>

      <template v-else-if="attachmentType === 'video'">
        <video class="videoInChat" controls controlslist="nodownload">
          <source :src="sanitizeHardLinkUrl(attachment)" type="video/mp4">
        </video>
      </template>

      <template v-else-if="attachmentType === 'location'">
        <iframe :src="getLatLongFromTheGoogleMapsUrl(attachment)" class="mapContainer" allowfullscreen="" loading="lazy" ></iframe>
      </template>
    </div>
  </div>
</template>

<script>

import { sanitizeHardLinkUrl, getLatLongFromTheGoogleMapsUrl } from '@/helpers/message.helpers';
import { renderNormalChat } from '@/helpers/text.helpers';

export default {
  mixins: [],
  props: {
    message: Object,
    activeCustomer: Object,
  },
  data() {
  },
  computed: {
    attachment() {
      return this.message?.template?.attachment;
    },
    attachmentType() {
      return this.message?.template?.attachmenttype;
    },
    replyToMessage() {
      return this.message?.replytomessage?.message;
    },
    replyToAttachment() {
      return this.message?.replytomessage?.template?.attachment;
    },
    replyToAttachmentType() {
      return this.message?.replytomessage?.template?.attachmenttype;
    },
    replyToTemplate() {
      return this.message?.replytomessage?.template?.length ? this.message.replytomessage.template[0] : undefined;
    },
    isReplyText() {
      return this.replyToAttachmentType === 'text' || this.replyToTemplate?.type === 'text';
    },
  },
  methods: {
    sanitizeHardLinkUrl,
    getLatLongFromTheGoogleMapsUrl,
    renderNormalChat,
  },
}
</script>

<style scoped>

.replytomessage_container{
  width: auto;
  max-width: 300px;
}

.replytomessage_container .innerDiv{
  position: relative;
  display: block;
  width: 100%;
  border: 1px #e4e6eb solid;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
}

.replytomessage_container .innerDiv .sourceMessage{
  border-color: var(--ion-color-primary);
}

.replytomessage_container .innerDiv .sourceMessage.textType{
  padding: 8px;
  background-color: var(--gray-01);
}

.replytomessage_container .innerDiv .replyMessage.textType{
  padding: 8px;
  background-color: var(--white);
}

.replytomessage_container .innerDiv .sourceMessage.imageType,
.replytomessage_container .innerDiv .sourceMessage.videoType{
  font-size: 0px;
}

.replytomessage_container .innerDiv .replyMessage.imageType,
.replytomessage_container .innerDiv .replyMessage.videoType{
  font-size: 0px;
}

.replytomessage_container .imageInChat,
.replytomessage_container .videoInChat{
  display: block;
  max-width: 100%;
  width: auto;
  height: auto;
  max-height: 300px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
}

.displayContainer {
  font-size: 13px;
  line-height: 1.3;
  text-decoration: underline;
  margin-bottom: 5px;
  display: block;
}

.flexContainer{
  display: flex;
  align-items: center;
  gap: 3px;
}

.textPadding {
  padding: 8px 8px 3px 8px;
}
.mapContainer {
  border:0;
  height: 200px;
  width: 300px;
  max-width: 100%;
  -webkit-border-radius: 5px;
  border-radius: 5px; 
  overflow: hidden;
}
</style>
